export enum PrimasNumberFilterOperator {
    IsEqualTo = "Is Equal To",
    IsNotEqualTo = "Is Not Equal To",
    IsGreaterThanOrEqualTo = "Is Greater Than Or Equal To",
    IsGreaterThan = "Is Greater Than",
    IsLessThanOrEqualTo = "Is Less Than Or Equal To",
    IsLessThan = "Is Less Than",
}
